import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loading from "react-fullscreen-loading";
import { useAuth } from "./AuthContext";
import { signinUrlFor } from "../utils/returnTo";

// Consumes the centrally-verified session from AuthContext — never reads
// localStorage directly for the userType.
export const UserRoute = ({ children }) => {
  const { status, userType } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <Loading loading={true} background="#fff" loaderColor="#883484" />;
  }
  if (status === "anon") {
    // Remember where they were headed so sign-in can send them back — this is
    // what makes a deep link in an email (e.g. the renewal email's
    // /User/RequestQuote?renew=…) survive a signed-out click. See utils/returnTo.
    return <Navigate to={signinUrlFor(location.pathname + location.search)} replace />;
  }
  if (userType === "user") {
    return children;
  }
  // "sales" is no longer a userType — it is a role inside the admin portal, so
  // sales users report userType "admin" and are covered by the branch below.
  if (userType === "admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }
  if (userType === "reseller") {
    return <Navigate to="/admin/resellerdashboard" replace />;
  }
  return <Navigate to="/signin" replace />;
};
